
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';

import MessageWrap from '@/components/MessageWrap/index.vue';

export default defineComponent({
	name: 'text-bot',

	components: {
		MessageWrap
	},

	props: {
		message: {
			type: Object as PropType<Message>
		},

		isShowMessageTail: {
			type: Boolean
		},

		avatar: {
			type: String
		}
	},

	emits: ['init'],

	mounted() {
		this.$emit('init');
	}
});
